import { Component, Input, LOCALE_ID, inject } from '@angular/core';
import {LDWDocument} from "../../shared/models/LDWDocument";
import {DocumentService} from "../../shared/services/document.service";
import { TranslateService } from '@ngx-translate/core';
import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';
import { LdwRouterService } from '../../route/ldw-router.service';

@Component({
    selector: 'ldw-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrls: ['./pdf-viewer.component.css'],
    standalone: false
})
export class PdfViewerComponent {
  private documentService = inject(DocumentService);
  private translateService = inject(TranslateService);
  private routerService = inject(LdwRouterService);
  private ngxExtendedPdfViewerService = inject(NgxExtendedPdfViewerService);


  private _document: LDWDocument | undefined = undefined;
  blob: Blob = new Blob();
  private oldid = "";

  @Input() printAllowed = false;
  @Input() downloadAllowed = false;
  @Input() search = '';
  @Input() pageNumber = 1;
  page = 1;

  @Input()
  get document(): LDWDocument | undefined {
    return this._document
  }

  set document(value: LDWDocument | undefined) {
    if (this._document == value) {
      return;
    }
    this._document = value;
    this.loadDocumentPdf(this._document?.id)
  }

  get selectedLanguage() {
    return this.translateService.currentLang;
  }

  loadDocumentPdf(docId: string | undefined) {
    if (docId == undefined) {
      return;
    }
    if (docId == this.oldid) {
      return;
    }
    this.oldid = docId;
    this.documentService.getPdf(docId).subscribe(
      res => {
        this.blob = res;
      }
    )
  }
  pdfDocumentLoaded(){
    // we have to set the page after the document is loaded
    if (this.pageNumber != 1) {
      this.page = this.pageNumber;
    }

    if (this.search != '') {
      const options = {
        highlightAll : true,
        matchCase : false,
        wholeWords : false,
        matchDiacritics : false
      };
      this.ngxExtendedPdfViewerService.find(this.search, options);
      this.search ="";
    }
  }
  pageChanged($event:any){
    this.routerService.setQueryParams('page', $event ?? '1')
  }

  zoomChanged($event:any){
    this.routerService.setQueryParams('zoom', $event ?? '1')
  }
}
